import { useMemo, useState } from 'react';
import styled from 'styled-components';
import Menu, { MenuOption } from '../../Menu';
import { AI_MODELS } from '../constants';
import { ModelProvider } from '../types';
import { MenuPillButton, MenuPillChevron } from './menuPill';

const ModelButton = styled(MenuPillButton)`
  background: transparent;
  color: ${({ theme }) => theme.palette.common.gray12};

  &:hover {
    background: ${({ theme }) => theme.palette.common.gray9};
  }
`;

type Props = {
  selectedModel: ModelProvider;
  onChange: (model: ModelProvider) => void;
};

const ModelMenuSelector = ({ selectedModel, onChange }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const options: MenuOption[] = useMemo(
    () =>
      AI_MODELS.map((model) => ({
        value: model.modelName,
        label: model.label,
        description: model.description,
      })),
    [],
  );

  if (AI_MODELS.length <= 1) {
    return null;
  }

  const handleChange = (modelName: string) => {
    const model = AI_MODELS.find((m) => m.modelName === modelName);
    if (model) {
      onChange(model);
    }
    setIsOpen(false);
  };

  return (
    <Menu
      menuButton={
        <ModelButton
          size="extraSmall"
          endIcon={<MenuPillChevron $isOpen={isOpen} />}
        >
          {selectedModel.label}
        </ModelButton>
      }
      options={options}
      selectedOptions={[selectedModel.modelName]}
      highlightSelected
      onChange={(value) => handleChange(value as string)}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      closeOnChange
      anchorOrigin={{ vertical: -8, horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    />
  );
};

export default ModelMenuSelector;
